import { render, staticRenderFns } from "./PrognoseLaadpunt.vue?vue&type=template&id=fd7ec214&"
import script from "./PrognoseLaadpunt.vue?vue&type=script&lang=js&"
export * from "./PrognoseLaadpunt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports